import React from 'react'
import { Property } from '../../service/cart'

export interface Props {
  property: Property
  price: any
  currency: string
  includeSecurityDeposit?: boolean
  extraData: any
  setExtraData: any
  data: any
  setData: any
  fetchData: any
  setLoading: any
}

const PropertyPrice: React.FunctionComponent<Props> = (props) => {
  const { extraData, setExtraData, data, setData, setLoading, fetchData, property, price, currency, includeSecurityDeposit} = props
  const moneyFormat = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
  })

  const setExtraQty = (category: string, name: string, qty: number) => {
    const catIndex: number = extraData.findIndex((cat: any) => {
      return cat.category === category
    })
    const extraIndex = extraData[catIndex].extras.findIndex((extra: any) => {
      return extra.name === name
    })

    const tmp = [ ...extraData ]
    tmp[catIndex].extras[extraIndex].qty = qty
    tmp[catIndex].extras[extraIndex].price.total = tmp[catIndex].extras[extraIndex].price.rate * qty
    setExtraData(tmp)

    const dataTmp = { ...data }
    dataTmp.properties[0].extras = tmp
    setData(dataTmp)

    setLoading(true)
    fetchData(false)
  }

  let balance = price.balance
  if (property.refundable_deposit && property.refundable_deposit.use)
    balance -= property.refundable_deposit.value

  const extras = property.extras.map(group => {
    group.extras = group.extras.filter(extra => {
      return !extra.is_hidden
    })

    if (!group.extras.length)
      return null

    const extrasContent = group.extras.map(extra => {
      const rate = extra.price.unit === 'percentage_rent' ? extra.price.rate : moneyFormat.format(extra.price.rate)
        
      if (extra.available.length === 1) {
        return <div key={extra.id}>
          <span>{extra.name}</span>
          <span>
            <div>x{extra.qty}</div>
            <div>{rate + extra.price.unit_label}</div>
          </span>
          <span>
            {moneyFormat.format(extra.price.total)}
          </span>
        </div>
      }

      const extraOptions = extra.available.map(a => <option key={a}>{a}</option>)
      const cat = extraData.find((x: any) => x.category === group.category)
      const extraInApi = cat.extras.find((x: any) => x.id === extra.id)

      return <div key={extra.id}>
        <span>{extra.name}</span>
        <span>
          <select onChange={(evt) => { setExtraQty(cat.category, extra.name, parseInt(evt.target.value)) }} value={extraInApi.qty}>
            {extraOptions}
          </select>
          <div>{rate + ' ' + extra.price.unit_label}</div>
        </span>
        <span>
          {moneyFormat.format(extra.price.total)}
        </span>
      </div>
    })

    return <div className="checkout_property__extras_inner" key={group.category}>
      <span className="checkout_property--bold">{group.category}</span>
      {extrasContent}
    </div>
  })

  return <>
    <div className="checkout_property__amounts">
      <div className="checkout_property__full_rate">
        <span className="checkout_property--bold">Full rate:</span>
        <span>{moneyFormat.format(price.total_original)}</span>
      </div>
      <div className="checkout_property__extras">
        <span className="checkout_property--bold">Extras</span>
        {extras}
      </div>
      <div className="checkout_property__deposit">
        <span className="checkout_property--bold">Deposit:</span>
        <span>{property.price.deposit.due && `Due ${property.price.deposit.due}`}</span>
        <span>{moneyFormat.format(price.deposit)}</span>
      </div>
      <div className="checkout_property__balance">
        <span className="checkout_property--bold">Balance:</span>
        <span>Due {property.price.balance.due}</span>
        <span>{moneyFormat.format(balance)}</span>
      </div>
      <div className="checkout_property__total">
        <span className="checkout_property--bold">Total:</span>
        <span className="checkout_property__total_final">{moneyFormat.format(price.total_final)}</span>
      </div>
      <div>
        {property.refundable_deposit && property.refundable_deposit.use &&
          <p className="text--x-sm">A refundable Security Deposit of {moneyFormat.format(property.refundable_deposit.value)} will be collected prior to arrival.</p>
        }
      </div>
    </div>
  </>
}

export default PropertyPrice

